import React, { useContext, useEffect, useState } from 'react';
import './voucher.css';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import { InvoiceContext } from '../../context/invoice/InvoiceContext';
import { MenuQRContext } from '../../context/menu/MenuQRContext';
import ProductCard, { getProductImageUrl } from './ProductCard';
import { Menu, Product } from '../../models/interfaces';
import ProductSummaryPage from './ConfirmOrderPage';
import { useNavigate } from "react-router-dom";
import Message from '../../components/ui/Message';

const PRELOAD_CONCURRENCY = 4;

// Imágenes de todos los productos en el orden en que aparecen en el menú (sin repetir)
const collectImageUrls = (menus: Menu[]): string[] => {
  const urls: string[] = [];
  const addProducts = (list?: Product[]) => (list ?? []).forEach(product => {
    const url = getProductImageUrl(product);
    if (url && !urls.includes(url)) urls.push(url);
  });
  (menus ?? []).forEach(menu => {
    addProducts(menu.products);
    (menu.submenu ?? []).forEach(sub => addProducts(sub.products));
  });
  return urls;
};

// Descarga las imágenes en segundo plano para que al abrir cada sección ya estén en caché
const preloadImages = (urls: string[], isCancelled: () => boolean) => {
  let next = 0;
  const loadNext = () => {
    if (isCancelled() || next >= urls.length) return;
    const img = new Image();
    img.decoding = 'async';
    img.onload = img.onerror = loadNext;
    img.src = urls[next++];
  };
  for (let i = 0; i < PRELOAD_CONCURRENCY; i++) loadNext();
};

const MenuQRPage: React.FC = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const { isLoading, loadMenuQR, products, selectedProducts, addProduct, removeProduct } = useContext(MenuQRContext);
  const [currency, setCurrency] = useState<string>("188");
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [openSubmenuId, setOpenSubmenuId] = useState<number | null>(null);

  const [summaryProducts, setSummaryProducts] = useState<Product[]>([]);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');


  const removeError = () => {
    setErrorMessage('');
  }


  useEffect(() => {
    const token = getTokenFromUrl(window.location.href);
    if (token && products.length == 0) {
      loadMenuQR(token);
    }
  }, []);


  useEffect(() => {
    setLogoUrl(logo);
  }, []);

  // Precarga de imágenes apenas llega el menú
  useEffect(() => {
    if (!products || products.length === 0) return;
    let cancelled = false;
    preloadImages(collectImageUrls(products as Menu[]), () => cancelled);
    return () => { cancelled = true; };
  }, [products]);


  const renderProducts = (products: Product[]) => {

    return products.map(product => {
      const p = selectedProducts.find((prod) => prod.id == product.id);
      const quantity = p?.quantity || 0;
      return (
        <ProductCard
          key={product.id}
          product={product}
          quantity={quantity}
          isSelected={p != null} // nueva prop
          onAdd={() => addProduct(product)}
          onRemove={() => removeProduct(product)}
        />
      );
    });
  };

  const getTokenFromUrl = (url: string): string | null => {
    const parts = url.split('/');
    return parts.length > 0 ? parts[parts.length - 1] : null;
  };

  const handleNext = async () => {
    if (Object.keys(selectedProducts).length === 0) {
      setErrorMessage('Debe seleccionar al menos un producto.')
    } else {
      navigate("/menuqr/confirm");
    }
  };

  const toggleMenu = (id: number) => {
    setOpenMenuId(prev => (prev === id ? null : id));
  };

  const toggleSubmenu = (id: number) => {
    setOpenSubmenuId(prev => (prev === id ? null : id));
  };

  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-info mt-5" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) :

        (
          <div className={isLoading ? "visually-hidden" : "wrapper1"}>
            <div className="headerLogin">
              <img src={logoUrl || ''} alt="Logo" className="logo" />
            </div>

            <div className="container-voucher my-5" style={{ paddingBottom: '80px' }}>


              <div className="row">
                <h1 style={{ textAlign: 'center' }}>Menú</h1>
                <div>
                  {products.map(menuItem => (
                    <div key={menuItem.id} className="mb-3">
                      <button
                        className="menu-accordion btn btn-secondary w-100 d-flex justify-content-between align-items-center"
                        style={{ height: '60px' }}
                        onClick={() => toggleMenu(menuItem.id)}
                      >
                        {menuItem.name}
                        <span>{openMenuId === menuItem.id ? <i className="bi bi-arrow-up-circle"></i> : <i className="bi bi-arrow-down-circle"></i>}</span>
                      </button>

                      {openMenuId === menuItem.id && (
                        <div className="p-3 border">
                          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {renderProducts(menuItem.products)}
                          </div>

                          {menuItem.submenu.map(sub => (
                            <div key={sub.id} className="mt-2">
                              <button
                                className="menu-accordion btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                                style={{ height: '60px' }}

                                onClick={() => toggleSubmenu(sub.id)}
                              >
                                {sub.name}
                                <span>{openSubmenuId === sub.id ? <i className="bi bi-arrow-up-circle"></i> : <i className="bi bi-arrow-down-circle"></i>}</span>
                              </button>

                              {openSubmenuId === sub.id && (
                                <div className="p-2 border">
                                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {renderProducts(sub.products)}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>




            </div>

            {/* Botón fijo abajo */}
            <div style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              width: '100%',
              backgroundColor: '#fff',
              padding: '10px',
              boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
              zIndex: 999
            }} className="d-flex justify-content-center">
              <button
                type="button"
                onClick={handleNext}
                className="btn btn-primary w-75"
              >
                Continuar
              </button>
            </div>

            {
              errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} /> : ''
            }
          </div>
        )}
    </div>
  );
};

export default MenuQRPage;
